import React, { useRef, useState } from "react";
import profileService from "../../services/profileService";
import { useAuth } from "../../contexts/AuthContext";
function getInitials(name) {
  if (!name) return "U";
  return String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join("");
}

function ProfileImageUpload({ currentUrl, initials, onUploaded }) {
    const { refreshProfile } = useAuth();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const pick = () => inputRef.current?.click();

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      setError("Image must be 2 MB or smaller");
      return;
    }
    setError("");
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      const res = await profileService.uploadImage(formData);
      //onUploaded?.(res.profileImageUrl);
      onUploaded?.(`${res.profileImageUrl}?v=${Date.now()}`);
      await refreshProfile();   // 👈 updates Header + Sidebar instantly
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to upload image");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="profile-image-block">
      <div className="profile-image">
        {currentUrl ? (
          <img src={currentUrl} alt="Profile" />
        ) : (
          <span>{getInitials(initials)}</span>
        )}
      </div>
      <div className="profile-image-actions">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={pick}
          disabled={uploading}
        >
          {uploading ? (
            <>
              <i className="fas fa-spinner fa-spin" /> Uploading...
            </>
          ) : (
            <>
              <i className="fas fa-camera" /> Change Photo
            </>
          )}
        </button>
        <small className="text-muted">JPG, PNG, GIF, WebP. Max 2 MB.</small>
      </div>
      {error && (
        <div className="error-text" style={{ marginTop: 6 }}>
          {error}
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/gif,image/webp"
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </div>
  );
}

export default ProfileImageUpload;